import React, { Fragment } from "react";
import {
	UsergroupAddOutlined,
	TeamOutlined,
	UsergroupDeleteOutlined,
	UserSwitchOutlined,
	DollarOutlined,
  EuroOutlined,
} from "@ant-design/icons";
import "./style.css";
import { Card, Col, Row, Statistic } from "antd";

const NewDashboardCard = ({ information }) => {
	return (
		<Fragment>
			<section className='mt-5 mb-5'>
				<div className='site-statistic-demo-card '>
					<Row gutter={[16, 16]} justify={"space-between"}>
						<Col xs={20} sm={16} md={12} lg={5} xl={5} style={{ display: 'flex' }}>
    <Card className='ant-shadow txt-color-2' bordered={false} style={{ height: '100%', width: '100%' }}>
      <Statistic
        title={<p className='text-xl txt-color-2'>TOTAL USERS</p>}
        loading={!information}
        value={information?.totalUsers}
        valueStyle={{ color: "#10b981" }}
        prefix={<TeamOutlined className='mr-4' style={{ fontSize: "35px" }} />}
      />
    </Card>
  </Col>

  <Col xs={20} sm={16} md={12} lg={5} xl={5} style={{ display: 'flex' }}>
    <Card className='ant-shadow txt-color-2' bordered={false} style={{ height: '100%', width: '100%' }}>
      <Statistic
        title={<p className='text-xl txt-color-2'>TOTAL PAYMENT</p>}
        loading={!information}
        value={information?.totalPayments || 0}
        precision={2}
        valueStyle={{ color: "#4f46e5" }}
        prefix={<EuroOutlined className='mr-4' style={{ fontSize: "35px" }} />}
      />
    </Card>
  </Col>

  <Col xs={20} sm={16} md={12} lg={5} xl={5} style={{ display: 'flex' }}>
    <Card className='ant-shadow txt-color-2' bordered={false} style={{ height: '100%', width: '100%' }}>
      <Statistic
        title={<p className='text-xl txt-color-2'>Total Admin Payment</p>}
        loading={!information}
        value={information?.adminTotalEarnings}
        precision={2}
        valueStyle={{ color: "#0891b2" }}
         prefix={<EuroOutlined className='mr-4' style={{ fontSize: "35px" }} />}
      />
    </Card>
  </Col>

  <Col xs={20} sm={16} md={12} lg={5} xl={5} style={{ display: 'flex' }}>
    <Card className='ant-shadow txt-color-2' bordered={false} style={{ height: '100%', width: '100%' }}>
      <Statistic
        title={<p className='text-xl txt-color-2'>TOTAL CUSTOMERS</p>}
        loading={!information}
        value={information?.totalCustomers}
        valueStyle={{ color: "#a855f7" }}
        prefix={<UserSwitchOutlined className='mr-4' style={{ fontSize: "35px" }} />}
      />
    </Card>
  </Col>

  <Col xs={20} sm={16} md={12} lg={4} xl={4} style={{ display: 'flex' }}>
    <Card className='ant-shadow txt-color-2' bordered={false} style={{ height: '100%', width: '100%' }}>
      <Statistic
        title={<p className='text-xl txt-color-2'>TOTAL SERVICE MAN</p>}
        loading={!information}
        value={information?.totalServiceman}
        valueStyle={{ color: "#f43f5e" }}
        prefix={<UsergroupDeleteOutlined className='mr-4' style={{ fontSize: "35px" }} />}
      />
    </Card>
  </Col>
					</Row>
				</div>
			</section>
		</Fragment>
	);
};

export default NewDashboardCard;
